/**
 * @ngdoc directive
 * @name footer
 *
 * @description
 * Page footer
 */
module.directive('footer', function () {
    'use strict';
    return {
        restrict: 'E',
        controller: ['$rootScope', '$scope', function ($rootScope, $scope) {
            $scope.site = $rootScope.site;
        }],
        template:
                '<div ng-switch="site.id" ng-if="!site.print">' +
                '  <footeravenir ng-switch-when="avenir"></footeravenir>' +
                '  <footerpanel ng-switch-when="b2c"></footerpanel>' +
                '</div>'
    };
});